var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"reset-scroll",rawName:"v-reset-scroll"}],staticClass:"filter-list",class:{
    mobile: _vm.isMobile,
    'search-btn-shown': _vm.isSearchAgain,
  }},[_c('div',{staticClass:"filter-list-inner",class:{
      mobile: _vm.isMobile,
      'search-btn-shown': _vm.isSearchAgain,
      'not-normal-map': _vm.isNotNormalMap,
      'tune-text-on': _vm.tuneTextOn,
    }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }